import React from "react";
import { ICustomTag } from "@/common/types/Types";

import styles from "./CustomTag.module.scss";

const CustomTag = (props: ICustomTag) => {
  const { icon, altIcon, name, backgroundColor } = props;
  const backStyle = backgroundColor
    ? {
        style: {
          backgroundColor,
          borderRadius: 1111,
          paddingLeft: 8,
          paddingRight: 8,
        },
      }
    : {};
  return (
    <div className={styles.wrapper} {...backStyle}>
      {icon && <img src={icon} alt={altIcon} width={16} height={16} />}
      <div className={styles.text}>{name}</div>
    </div>
  );
};

export default CustomTag;
